import React from 'react';
import { useState } from "react";
import { FaMapMarkedAlt } from "react-icons/fa";
import { IconContext } from "react-icons/lib";
import {
  JobsCalendar,
  UpcomingJobs,
  JobMap,
  // Charts,
} from "../../components/Dashboard";

function Dashboard() {


  const [chosenAppt, setChosenAppt] = useState(null);

  const MapLink = ({ address }) => {
    return (
      <a
        href={`https://www.google.com/maps/place/${address}/`}
        target="_blank"
        rel="noreferrer"
      >
        <IconContext.Provider value={{ className: "map-icon" }}>
          <FaMapMarkedAlt />
        </IconContext.Provider>
      </a>
    );
  };

  return (
    <div className="dashboard page">
      {/* ----- Job Map ------ */}
      <JobMap
        chosenAppt={chosenAppt}
        setChosenAppt={setChosenAppt}
        MapLink={MapLink}
      />
      {/* ----- Upcoming Jobs ------ */}
      <UpcomingJobs
        chosenAppt={chosenAppt}
        setChosenAppt={setChosenAppt}
        MapLink={MapLink}
      />
      {/* ----- Calendar ------ */}
      <JobsCalendar chosenAppt={chosenAppt} setChosenAppt={setChosenAppt} />
      {/* ----- Summary Reports ------ */}
      
    </div>
  );
}
export default Dashboard;